import React, { Component } from "react";
import PropTypes from "prop-types";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";

import i18n from "../../../../translations/i18n";
import {
  openModal,
  closeModal,
} from "../../../../actions/modalActions";
import BaseModal from "../../../../components/ui/modal/base";
import { UNCONFIRMED_MODAL } from "../../../../constants/modalConstants";


class UnconfirmedWarningModal extends Component {

  constructor(props) {
    super(props);
  }

  handleClose = (event) => {
    if (event) {
      event.preventDefault();
    }
    this.props.closeModal();
  }

  render() {
    const { modal } = this.props;

    return (
      <BaseModal
        className="modal"
        isOpen={modal.name === UNCONFIRMED_MODAL}
        onClose={this.handleClose}
      >
        <div className="modal__title">
          {i18n.t('modal.unconfirmed.title')}
        </div>
        <div className="modal__form">
          {i18n.t('modal.unconfirmed.text')}
        </div>
      </BaseModal>
    )
  }
}

UnconfirmedWarningModal.propTypes = {
  openModal: PropTypes.func.isRequired,
  closeModal: PropTypes.func.isRequired,
};

function mapStateToProps({layout}) {
  return {
    modal: layout.modal,
  }
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators({
    openModal,
    closeModal,
  }, dispatch)
}

export default connect(mapStateToProps, mapDispatchToProps)(UnconfirmedWarningModal)